import ApiService from '@/helpers/api.service';

const API = new ApiService();

// Endpoints

export const state = {
    errors: null
}

export const mutations = {
}

export const actions = {
    pushMobileNotification(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/notification/push`, params)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            });
        });
    }
}

export const getters = {
    
}